import { default as routes } from './routes';

export default {
    ...routes
};
